import { css, styled } from 'styled-components';

const SelectMenuIcon = styled.div<{
  $position?: 'left' | 'right';
  $size?: number;
}>`
  ${({ $position = 'left', $size = 24 }) => css`
    display: flex;
    align-items: center;

    ${$position === 'left'
      ? css`
          margin-right: 12px;
        `
      : css`
          margin-left: auto;
        `}
    width: ${$size}px;
    height: ${$size}px;
  `}
`;

SelectMenuIcon.displayName = 'SelectMenu.LinkIcon';

export { SelectMenuIcon };
